import _ from "lodash";

import { localRequest } from "../../apiUtils";
import { setLoading } from "../app/actions";
import Swal from "helpers/swal";
import { getTranslation } from "helpers/common";

export const actionTypes = {
  SEND_CONTACT_FORM_REQUEST: "SEND_CONTACT_FORM_REQUEST",
  SEND_CONTACT_FORM_SUCCESS: "SEND_CONTACT_FORM_SUCCESS",
  SEND_CONTACT_FORM_FAILURE: "SEND_CONTACT_FORM_FAILURE"
};

export default class Actions {
  public static sendContactForm(params) {
    return async dispatch => {
      dispatch(request());
      dispatch(setLoading(true));

      try {
        const { data } = await localRequest.post("send_email", params);
        dispatch(success(data));
        dispatch(setLoading(false));
        Swal.toast(getTranslation("MESSAGE_SENT"));
      } catch (error) {
        const errorMessage = error.response
          ? error.response.data
          : getTranslation("EMAIL_ERROR");
        dispatch(failure(error));
        dispatch(setLoading(false));
        Swal.toast({ title: errorMessage, type: "error" });
      }
    };

    function request() {
      return { type: actionTypes.SEND_CONTACT_FORM_REQUEST };
    }
    function success(payload) {
      return {
        type: actionTypes.SEND_CONTACT_FORM_SUCCESS,
        payload
      };
    }
    function failure(error) {
      return { type: actionTypes.SEND_CONTACT_FORM_FAILURE, error };
    }
  }
}
